export default "__VITE_ASSET__5rcBCu9C__"